export const css = {
    root: '_2hSi0msO',
    title: '_1Z4fFx0Z',
    body: '_3GFLhXsB',
    warning: '_3gcOml5O',
    ' _key': 'rise-activation/rise'
};
export default css;
